export const MAIN_TEAMS = ["A", "B", "C", "D"] as const;

export type MainTeam = (typeof MAIN_TEAMS)[number];

export const ORGANIZATION_UNITS = ["COMPOSITE", "STRUCTURAL", "PAINT", "R1_R2"] as const;
export type OrganizationUnit = (typeof ORGANIZATION_UNITS)[number];
export const ORGANIZATION_UNIT_LABELS: Readonly<Record<OrganizationUnit, string>> = {
  COMPOSITE: "Kompozit",
  STRUCTURAL: "Yapısal",
  PAINT: "Boya",
  R1_R2: "R1-R2",
};

export const SCHEDULE_PATTERNS = [
  "A1",
  "A2",
  "A3",
  "A4",
  "B1",
  "B2",
  "B3",
  "B4",
  "C1",
  "C2",
  "C3",
  "C4",
  "D1",
  "D2",
  "D3",
  "D4",
] as const;

export type SchedulePattern = (typeof SCHEDULE_PATTERNS)[number];

export const SHIFTS = ["SABAH", "OGLE", "GECE", "OFF"] as const;

export type Shift = (typeof SHIFTS)[number];

export const SHIFT_LABELS: Readonly<Record<Shift, string>> = {
  SABAH: "Sabah",
  OGLE: "Öğle",
  GECE: "Gece",
  OFF: "OFF",
};

export const ROLES = ["employee", "chief", "supervisor", "manager", "admin"] as const;

export type Role = (typeof ROLES)[number];

export const ROLE_LABELS: Readonly<Record<Role, string>> = {
  employee: "Personel",
  chief: "Başteknisyen",
  supervisor: "Şef",
  manager: "Müdür",
  admin: "Sistem yöneticisi",
};

export const MANAGEMENT_SHIFTS = ["R1", "R2", "DAY_08_17"] as const;

export type ManagementShift = (typeof MANAGEMENT_SHIFTS)[number];

export const LEAVE_TYPES = [
  "ANNUAL",
  "EXCUSE",
  "MARRIAGE",
  "BEREAVEMENT",
  "MEDICAL_REPORT",
  "TRAINING",
  "DUTY",
  "FLIGHT",
  "MILITARY",
  "OTHER",
] as const;

export type LeaveType = (typeof LEAVE_TYPES)[number];

export const LEAVE_TYPE_LABELS: Readonly<Record<LeaveType, string>> = {
  ANNUAL: "Yıllık izin",
  EXCUSE: "Mazeret izni",
  MARRIAGE: "Evlilik izni",
  BEREAVEMENT: "Cenaze izni",
  MEDICAL_REPORT: "Rapor",
  TRAINING: "Eğitim",
  DUTY: "Görev",
  FLIGHT: "Uçuş",
  MILITARY: "Askerlik",
  OTHER: "Diğer",
};

export const LEAVE_DURATIONS = ["FULL_DAY", "HALF_DAY", "TWO_HOURS"] as const;

export type LeaveDuration = (typeof LEAVE_DURATIONS)[number];

export const PARTIAL_DAY_TIMINGS = ["LATE_ARRIVAL", "EARLY_DEPARTURE"] as const;

export type PartialDayTiming = (typeof PARTIAL_DAY_TIMINGS)[number];

export const LEAVE_REQUEST_STATUSES = [
  "PENDING",
  "APPROVED",
  "REJECTED",
  "CANCELLATION_PENDING",
  "CHANGE_PENDING",
  "CANCELLED",
  "SUPERSEDED",
] as const;

export type LeaveRequestStatus = (typeof LEAVE_REQUEST_STATUSES)[number];

export const REQUEST_STATUS_LABELS: Readonly<Record<LeaveRequestStatus, string>> = {
  PENDING: "Bekliyor",
  APPROVED: "Onaylandı",
  REJECTED: "Reddedildi",
  CANCELLATION_PENDING: "İptal bekliyor",
  CHANGE_PENDING: "Değişiklik bekliyor",
  CANCELLED: "İptal edildi",
  SUPERSEDED: "Değiştirildi",
};

export const SHIFT_REQUEST_STATUSES = [
  "PENDING",
  "APPROVED",
  "REJECTED",
  "CANCELLATION_PENDING",
  "CANCELLED",
] as const;

export type ShiftRequestStatus = (typeof SHIFT_REQUEST_STATUSES)[number];

/** All persisted skill codes, including legacy values kept for history. */
export const SKILLS = [
  "QMSTR",
  "L1",
  "L2",
  "B1",
  "QMSTR_L1",
  "QMSTR_L2",
  "CQM",
  "TAP_TEST",
] as const;

/** Skill choices exposed by current personnel-management flows. */
export const MANAGEABLE_SKILLS = ["QMSTR_L1", "QMSTR_L2", "CQM", "B1", "TAP_TEST"] as const;

export type Skill = (typeof SKILLS)[number];
export type ManageableSkill = (typeof MANAGEABLE_SKILLS)[number];

export function teamForSchedulePattern(pattern: SchedulePattern): MainTeam {
  return pattern.charAt(0) as MainTeam;
}

export function isSchedulePatternForTeam(pattern: SchedulePattern, team: MainTeam): boolean {
  return teamForSchedulePattern(pattern) === team;
}
